// extracted by mini-css-extract-plugin
module.exports = {"root":"StreamTablePreview-module__root__32Kpp","new-what-column":"StreamTablePreview-module__new-what-column__6cymj"};